<template>
    <!-- Same BS Labs Confirm dialog as confirm-dialog; this name stays for its callers. -->
    <confirm-dialog ref="dialog"></confirm-dialog>
</template>
<script>
import ConfirmDialog from './ConfirmDialog.vue';

export default {
    components: { ConfirmDialog },
    methods: {
        open(title, message, options) {
            return this.$refs.dialog.open(title, message, options);
        }
    }
};
</script>
